(function () {
  var KEY = 'seller_refs_v1';
  var DAYS = 30; // attribution window

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function save(data) {
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {}
  }
  function handleFromPath() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function handleFromForm(form) {
    var a = form.getAttribute('action') || '';
    var m = a.match(/\/products\/([^\/?#]+)/);
    if (m) return decodeURIComponent(m[1]);
    return form.getAttribute('data-product-handle') || handleFromPath();
  }

  // 1) Capture ?ref=XXX for this product
  var ref = new URLSearchParams(location.search).get('ref');
  var handle = handleFromPath();
  var data = load();
  if (ref && handle) {
    data[handle] = { s: ref.toUpperCase(), t: Date.now() }; // latest link wins
    save(data);
  }

  // 2) Fill a hidden _seller input in every add-to-cart form
  function fresh(entry) {
    return entry && (Date.now() - entry.t) < DAYS * 86400000;
  }
  function apply() {
    var d = load();
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var h = handleFromForm(form);
      var entry = h && d[h];
      var input = form.querySelector('input[name="properties[_seller]"]');
      if (!fresh(entry)) { if (input) input.remove(); return; }
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_seller]';
        form.appendChild(input);
      }
      input.value = entry.s;
    });
  }
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('submit', apply, true); // refresh right before submit
})();